// src/pages/Callback.js
import { useEffect } from 'react';
import Storage from '../../../../utills/AsyncStorage';
import { redirect_uri } from '../../../../utills';
import { roles } from '../../../../config/roles';

function Callback() {
  useEffect(() => {
    const role = Storage.getERole("@role");

    const code = new URLSearchParams(window.location.search).get('code');
    const verifier = localStorage.getItem('verifier');
    const REDIRECT_URI = redirect_uri();
    // const redirectTo = role == roles.client ? 'http://127.0.0.1:8000/events' : role == roles.vendor ? 'http://127.0.0.1:8000/songIdeas' : 'http://127.0.0.1:8000/';
    const redirectTo = role == roles.client ? `${REDIRECT_URI}events`  : role == roles.vendor ? `${REDIRECT_URI}songIdeas` :  `${REDIRECT_URI}` ;

    if (!code || !verifier) return;
    fetch('https://accounts.spotify.com/api/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        client_id: 'cbd536439be2450aa0709cb1c39ffcba',
        grant_type: 'authorization_code',
        code,
        redirect_uri: `${REDIRECT_URI}callback`,
        code_verifier: verifier,
      }),
    })
      .then(res => res.json())
      .then(data => {
        console.log('data', data)
        const expiresIn = data.expires_in; // usually 3600 seconds
        const expiresAt = Date.now() + expiresIn * 1000;

        localStorage.setItem("refresh_token", data?.refresh_token);
        localStorage.setItem("expires_at", expiresAt);

        localStorage.setItem("access_token", data?.access_token);
        if (data?.access_token) {
          window.location.href = redirectTo;
        }else{
          localStorage.setItem("access_token", data?.access_token);
        }
        // window.location.href = redirectTo;
      });
  }, []);

  return <p>Authenticating...</p>;
}

export default Callback;